import { render, staticRenderFns } from "./LaboratoryRequestDataTable.vue?vue&type=template&id=49225107"
import script from "./LaboratoryRequestDataTable.vue?vue&type=script&lang=js"
export * from "./LaboratoryRequestDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports